import React, { Component, createRef } from 'react';
import { Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import locationProduct from '../../../assets/location-product.png';
import './index.less';
function chunk(array, size) {
  //获取数组的长度，如果你传入的不是数组，那么获取到的就是undefined
  const length = array.length;
  //判断不是数组，或者size没有设置，size小于1，就返回空数组
  if (!length || !size || size < 1) {
    return [];
  }
  //核心部分
  let index = 0; //用来表示切割元素的范围start
  let resIndex = 0; //用来递增表示输出数组的下标

  //根据length和size算出输出数组的长度，并且创建它。
  let result = new Array(Math.ceil(length / size));
  //进行循环
  while (index < length) {
    //循环过程中设置result[0]和result[1]的值。该值根据array.slice切割得到。
    result[resIndex++] = array.slice(index, (index += size));
  }
  //输出新数组
  return result;
}

const contentStyle = {
  color: '#fff',
  textAlign: 'center',
  display: 'flex',
};
export default class Swiper extends Component {
  constructor(props) {
    super(props);
    const { products = [] } = props;
    this.state = {
      current: 1,
      productList: chunk(products, 5)
    };
    this.carouselRef = createRef();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { products = [] } = nextProps;
    this.setState({ productList: chunk(products, 5) });
  }
  prev = () => {
    if (this.state.current > 1) {
      this.setState({ current: this.state.current - 1 }, () => this.carouselRef.prev());
    }
  }
  next = () => {
    if (this.state.current < this.state.productList.length) {
      this.setState({ current: this.state.current + 1 }, () => this.carouselRef.next());
    }
  }
  render() {
    const { productList, current } = this.state;
    return (
      <>
        {
          productList.length ? <div className='swiper-container'>
            <div className='swiper-list'>
              <LeftOutlined style={{ color: current === 1 ? '#E0E0E0' : '' }} onClick={() => this.prev()} />
              <div className='swiper-carousel'>
                <Carousel dots={false} ref={el => { this.carouselRef = el; }}>
                  {productList.map((item, index) => {
                    return <div key={index}>
                      <>
                        <div>
                          <h3 style={contentStyle}>
                            {
                              item.map((subItem, subIndex) => {
                                return <div className='swiper-item' key={subIndex}>
                                  <img src={subItem.product_image || locationProduct} alt={subItem.product_name}></img>
                                  <div className='swiper-item-name'>{subItem.product_name}</div>
                                </div>;
                              })
                            }
                          </h3>
                        </div>
                      </>
                    </div>;
                  })}
                </Carousel>
              </div>
              <RightOutlined style={{ color: current === productList.length ? '#E0E0E0' : '' }} onClick={() => this.next()} />
            </div>
          </div> : null
        }</>
    );
  }
}
